
// const isRightHandler=()=>{
 const role= localStorage.getItem("vedic_role")
 const rights=localStorage.getItem("vedic_rights");
// }

// console.log(role,"Is Rights Handler");
// console.log(rights,"Is Rights Handler");


// Auth

export const auth = {
  FORGET_PASSWORD_ROUTE: "/forgot-password",
  RESET_PASSWORD_ROUTE: "/reset-password",
};

// User

export const user = {
  USER_MANAGEMENT: "/user",
  USER_DETAIL: "/user/user-detail",
  USER_DELETE:"/user/delete",
  RIGHTS:true
};

export const powerCustomer = {
  POWER_CUSTOMER: "/power-customer",
};

// Consulant

export const consultant = {
  CONSULTANT_MANAGEMENT: "/consultant-management",
  PRE_SELECTED_CONSULTANT: "/pre-selected-consultant",
  ASTROLOGER_REGISTRATION_FORM: "/astrologer-registration-form",
  CONSULTANT_DETAIL: "/consultant-management/consultant-detail",
  CONSULTANT_ADD: "/consultant-management/add",
  CONSULTANT_DELETE: "/consultant-management/delete",
  CONSULTANT_EDIT: "/consultant-management/edit",
  CONSULTANT_EDIT_V1: "/consultant-management/edit-v1",
  CONSULTANT_CHECK_PERFORMANCE: "/consultant-management/check-performance",
  CONSULTANT_KPI: "/consultant-management/kpi",
  CONSULTANT_PERFORMANCE: "/consultant-performance",
  CONSULTANT_PERFORMANCE_ALERTS: "/consultant-performance-alerts",
  OPERATIONS_ECOSYSTEM: "/operations-ecosystem",
  POWER_CUSTOMER_RETURN: "/power-customer-return",
  RIGHTS:true
};

// Dashboard

export const waitlist={
   WAITLIST_MANAGEMENT: "/waitlist-management",
}
// booked waitlist
export const bookedwaitlist={
  BOOKED_WAITLIST: "/booked-waitlist",
}
// waitlist 

export const failed={
   FAILED_CONSULTATION: "/failed-consultation",
}

export const Missed={
   MISSED_CALL_CHAT: "/missed-call-chat",
}

export const Completed={
   COMPLETED_CALL_CHAT: "/completed-call-chat",
   COMPLETED_QUERIES: "/completed-queries",
}


export const Progress={
   PROGRESS_CALL_CHAT: "/progress-call-chat",
}


  export const Onlineoffline={
   ONLINE_OFFLINE_CONSULTANT: "/online-offline-consultant",
}

export const FlagRequest={
  FLAG_REQUEST: "/flag-request",
}



export const dashboard = {
  DASHBOARD: "/dashboard",
  DASHBOARD_2: "/dashboard-marketing",
  ENHANCED_DASHBOARD: "/enhanced-dashboard",
  ANALYTICS_DASHBOARD: "/analytics-dashboard",
  CLAUDE_DATA_ANALYSIS: "/claude-data-analysis",
  DASHBOARD_MATRIX_ANALYTICS: "/dashboard-matrix-analytics",
  DAILY_CONSULT_PERFORMANCE: "/daily-consult-performance",
  RIGHTS: true,
};
// Category

export const category = {
  CATEGORY: "/category",
  ADD_MEDIA: "/category/add-media",
  RIGHTS:true
};

// Banner

export const banner = {
  BANNER: "/banner",
  RIGHTS:true
};

// Ecommerce
export const ecommerce = {
  ECOMMERCE: "/ecommerce-management",
  RIGHTS:true
};

// Music

export const music = {
  MUSIC_LIST: "/music-category",
  MUSIC_DETAIL: "/music-category/add-music",
  RIGHTS:true
};

// Medication

export const meditation = {
  MEDITATION_LIST: "/meditation",
  MEDITATION_CATEGORY_LIST: "/meditation-category",
  MEDITATION_DETAIL: "/meditation-category/add-meditation",
  MEDITATION_DASHBOARD: "/meditation-dashboard",
  RIGHTS:true
};

// Trainig management

export const training = {
  TRAINING_LIST: "/training-category",
  TRAINING_DETAIL: `/training-category/add-training`,
  RIGHTS:true
};

export const image = {
  IMAGE_LIST: "/image-management",
  IMAGE_DETAIL: `/image-management/approve-image`,
  RIGHTS:true
};

export const cms = {
  CONTENT_MANAGEMENT: "/content-management",
};

//  Vastu Compass Category
export const vastuCompass = {
  VASTU_COMPASS_CATEGORY: "/vastu-compass-category",
  VASTU_COMPASS_CATEGORY_DETAIL: "/vastu-compass-category/view",
  RIGHTS:true
};

//  Gift Management
export const gift = {
  GIFT_MANAGEMENT: "/gift-management",
  RIGHTS:true
};

// Segment Management
export const segment = {
  SEGMENT_LIST: "/segments",
  SEGMENT_BUILDER: "/segments/builder",
  SEGMENT_DETAIL: "/segments/detail",
  RIGHTS:true
};

//  Community Management
export const community = {
  COMMUNITY_MANAGEMENT: "/community-management",
  COMMUNITY_DETAIL: "/community-management/view",
  COMMUNITY_CHAT: "/community-management/view/chat",
  RIGHTS:true
};

// Explore Management
export const explore = {
  EXPLORE_MANAGEMENT: "/explore-management",
  EXPLORE_LIST: "/explore",
  EXPLORE_DETAIL: "/explore-management/view",
  USER_ACTIVITY_LOG: "/explore-management/user-activity-log",
  RIGHTS:true
};

// Refer Earn
export const refer = {
  REFER_MANAGEMENT: "/refer-management",
  RIGHTS:true
};

// Refer Earn
export const request = {
  REQUEST_MANAGEMENT: "/request-management",
  RIGHTS:true
};

// Discount Management
export const discount = {
  DISCOUNT_MANAGEMENT: "/discount-management",
  RIGHTS:true
};
// Horoscope Management
export const horoscope = {
  HOROSCOPE_MANAGEMENT: "/horoscope-management",
  VIEW: "/horoscope-management/view",
  RIGHTS:true
};

// Live Management
export const live = {
  LIVE_MANAGEMENT: "/live-management",
  RIGHTS:true
};

// Notification Management
export const notification = {
  NOTIFICATION_MANAGEMENT: "/notification-management",
  ADD_NOTIFICATION: "/notification-management/add",
  RIGHTS:true
};

// Support Management
export const support = {
  SUPPORT_MANAGEMENT: "/support-management",
  ADD_SUPPORT: "/support-management/add",
  VIEW_SUPPORT:"/support-management/view",
  QUERY_MASTERS: "/support-management/query-masters",
  RIGHTS:true
};
// Feedback Management
export const feedback = {
  FEEDBACK_MANAGEMENT: "/feedback-management",
  RIGHTS:true
};
// Form
export const form = {
  FORM: "/form-16A/:consultantId",
  RIGHTS:true
};
// Shopify
export const shopify = {
  SHOPIFY: "/shopify/:consultantId",
  RIGHTS:true
};

// Shopify Consultant COmmission
export const commission = {
  COMMISSION: "/commission",
  RIGHTS:true
};

// Concern
export const concern = {
  CONCERN: "/concern-management",
  CONCERN_DETAIL: "/concern-management/add-remedy",
  RIGHTS:true
};

// Transaction
export const transaction = {
  TRANSACTION: "/transaction-management",
  RIGHTS:true
};
// admin notifications
export const AdminNotifications = {
 ADMINNOTIFICATION: "/admin-notification" , 
 RIGHTS:true
};
// Offers Management
export const offers = {
  OFFERS: "/offers-management",
  RIGHTS:true
};

// Offer Engine
export const offerEngine = {
  OFFER_VARIANTS: "/offer-engine/variants",
  OFFER_RULES: "/offer-engine/rules",
  RIGHTS: true
};

// Offers Management
export const marketing = {
  MARKETING: "/marketing-management",
  RIGHTS:true
};
// Consultant Payout
export const consultantPayout = {
  PAYOUT: "/consultant-payout",
  RIGHTS:true
};



// Subadmin
export const subadmin = {
  SUBADMIN: "/subadmin",
  ADDSUBADMIN: "/subadmin/add",
  EDITSUBADMIN: "/subadmin/edit/:subAdminId",
  VIEWSUBADMIN: "/subadmin/view/:subAdminId",
  RIGHTS:true
};


export const insight = {
  INSIGHT: "/insight-management",
  USER_INSIGHT: "/user-insight",
  CONSULTANT_INSIGHT: "/consultant-insight",
  RIGHTS:true
};

// Management Dashboard
export const management = {
  MANAGEMENT: "/management",
  RIGHTS:true
};

// Analytics Management
export const analytics = {
  ANALYTICS: "/analytics-management",
  USER_ANALYTICS: "/analytics-management/user/:userId",
  DEVICE_ANALYTICS: "/analytics-management/device/:deviceId",
  RIGHTS:true
};

// Purchase Analytics
export const purchaseAnalytics = {
  PURCHASE_ANALYTICS: "/purchase-analytics",
  USERS_BY_PURCHASE_COUNT: "/purchase-analytics/users/:purchaseCount",
  RIGHTS:true
};
// Settings
export const settings = {
  SETTINGS: "/settings",
  RIGHTS:true
};

// Playstore Screenshot Management
export const playstoreScreenshot = {
  PLAYSTORE_SCREENSHOT: "/playstore-screenshot-management",
  RIGHTS:true
};
// UTM Management
export const utmManagement = {
  UTM_MANAGEMENT: "/utm-management",
  RIGHTS:true
};

// Customer Problem Identification
export const customerProblem = {
  CUSTOMER_PROBLEM: "/customer-problem-identification",
  RIGHTS: true,
};

// Activity Log
export const activityLog = {
  ACTIVITY_LOG: "/activity-log",
  RIGHTS: true,
};

export const cronJobs = {
  CRON_JOBS: "/cron-jobs",
  RIGHTS: true,
};


// ── V2 Coupon System ─────────────────────────────────────────────────────────
export const couponsV2 = {
  COUPONS_V2:        "/coupons-v2",
  COUPON_V2_CREATE:  "/coupons-v2/create",
  COUPON_V2_EDIT:    "/coupons-v2/edit/:id",
  RIGHTS: true,
};

// Influencer Management
export const influencerManagement = {
  INFLUENCER_LIST:    "/influencer-management",
  INFLUENCER_CREATE:  "/influencer-management/create",
  INFLUENCER_DETAIL:  "/influencer-management/detail/:id",
  INFLUENCER_LEDGER:  "/influencer-management/detail/:id/ledger",
  INFLUENCER_SETTLE:  "/influencer-management/detail/:id/settle",
  RIGHTS: true,
};
